import { render, staticRenderFns } from "./returnGoodsTask.vue?vue&type=template&id=5d11413c&scoped=true"
import script from "./returnGoodsTask.vue?vue&type=script&lang=js"
export * from "./returnGoodsTask.vue?vue&type=script&lang=js"
import style0 from "./returnGoodsTask.vue?vue&type=style&index=0&id=5d11413c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d11413c",
  null
  
)

export default component.exports